import jwtDecode, { JwtPayload } from 'jwt-decode';

export const deriveUserIdFromToken = (token: string): number => {
  const decoded = jwtDecode<JwtPayload>(token);
  return Number(decoded?.sub?.split(':')[1]);
};
